import React from "react";
import _ from "lodash";
import { InfoPopover, HoursOfOperationV2 } from "@unite-us/client-utils";
import { Icon } from "@unite-us/ui";
import VoiceMailOk from "../../ContactRequirements/components/VoiceMailOk";
import MethodsOfContact from "../../ContactRequirements/components/MethodsOfContact";
export default function ContactRequirementsBanner(_ref) {
  var contact_preference = _ref.contact_preference,
    enums = _ref.enums;
  var timeslots = contact_preference.timeslots,
    _contact_preference$p = contact_preference.preferred_contact_methods,
    contactMethods = _contact_preference$p === void 0 ? [] : _contact_preference$p,
    _contact_preference$v = contact_preference.voice_mail_ok,
    isVoicemailOK = _contact_preference$v === void 0 ? null : _contact_preference$v,
    contactNotes = contact_preference.contact_notes;
  var showVoiceMailOk = _.includes(contactMethods, "phone") && isVoicemailOK != null;
  var warnContactNotes = !!contactNotes;
  var warnVoicemail = _.includes(contactMethods, "phone") && isVoicemailOK === false;
  var warnTimeslots = !_.isEmpty(timeslots);
  var showContactRequirementsBanner = warnContactNotes || warnVoicemail || warnTimeslots;
  if (!showContactRequirementsBanner) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex mt-4 text-red"
  }, /*#__PURE__*/React.createElement("div", null, "This client has specific contact requirements. Check these requirements before contacting the client."), /*#__PURE__*/React.createElement(Icon, {
    icon: "IconInfoCircle",
    className: "ml-1 mb-0.5",
    color: "#CF2A2A",
    id: "anchor-id-info-popover-contact-methods"
  }), /*#__PURE__*/React.createElement(InfoPopover, {
    id: "info-popover-contact-methods",
    placement: "bottom-start",
    hiddenTooltip: false,
    tooltipText: /*#__PURE__*/React.createElement("div", {
      className: "p-4 text-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-3"
    }, "Methods of Contact:"), /*#__PURE__*/React.createElement(MethodsOfContact, {
      contactMethods: contactMethods,
      enums: enums
    })), showVoiceMailOk && /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(VoiceMailOk, {
      contactMethods: contactMethods,
      isVoicemailOK: isVoicemailOK
    })), !_.isEmpty(timeslots) && /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(HoursOfOperationV2, {
      closedText: "Do not contact",
      endTimeKey: "end_time",
      hours: timeslots,
      hoursLabel: "Contact Times:",
      showAll: true,
      startTimeKey: "start_time"
    })), contactNotes && /*#__PURE__*/React.createElement("div", {
      className: "flex mt-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-3 whitespace-pre"
    }, "Contact Notes:"), /*#__PURE__*/React.createElement("div", null, contactNotes)))
  }));
}
//# sourceMappingURL=index.js.map